module.exports = __webpack_public_path__ + "img/20190529162522QQ截图20190527165002.46505c50.png";